module.exports = __webpack_public_path__ + "static/media/book-mockup-store.7545c4a3.png";